import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Col, Form, Row } from 'antd';

import DatePicker from '@/views/components/Inputs/DatePicker';

import { routeFileSelector } from '../../../../../utilz/i18n';
import FormInput from '../../../../components/Inputs/FormInput';
import FormLabel from '../../../../components/Labels/FormLabel';
import TransportationProviderSelector from '../../../../components/Selectors/AsynchSearch/TransportationProviderSelector';
import LADClaimProcessorSelector from '../../../../components/Selectors/LADClaimProcessorSelector';
import LADClaimsBranchByDivisionRegionSelector from '../../../../components/Selectors/LADClaimsBranchByDivisionRegionSelector';
import LADClaimsDivisionSelector from '../../../../components/Selectors/LADClaimsDivisionSelector';
import LADClaimsRegionSelector from '../../../../components/Selectors/LADClaimsRegionSelector';
import LossAndDamageClaimStatusSelector from '../../../../components/Selectors/LossAndDamageClaimStatusSelector';
import { PreClaimsTypeSelect } from '../../PreClaims';

const AdvancedFilters = ({ filterForm }) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const divisionKey = Form.useWatch('divisionKey', filterForm);
  const regionKey = Form.useWatch('regionKey', filterForm);
  const startDate = Form.useWatch('startDate', filterForm);
  const endDate = Form.useWatch('endDate', filterForm);
  return (
    <div className="px-15 h-100 custom-scroll-bar">
      <FormInput editMode label="Claim Number" margin="mb-10" name="claimNo" />
      <FormInput editMode label="Freight Bill / Pro Number" margin="mb-10" name="freightBillNo" />
      <FormInput editMode label="Invoice Number" margin="mb-10" name="invoiceNo" />
      <FormInput editMode label="Consignee" margin="mb-10" name="consignee" />
      <LADClaimsDivisionSelector editMode label="Division" margin="mb-10" name="divisionKey" />
      <LADClaimsRegionSelector editMode label="Region" margin="mb-10" name="regionKey" divisionKey={divisionKey} />
      <LADClaimsBranchByDivisionRegionSelector
        editMode
        label="Branch"
        margin="mb-10"
        name="branchKey"
        divisionKey={divisionKey}
        regionKey={regionKey}
      />
      <TransportationProviderSelector
        editMode
        label="Transportation Provider"
        margin="mb-10"
        name="carrierKey"
        form={filterForm}
      />
      <PreClaimsTypeSelect label="Claim Type" name="claimType" margin="mb-10" />
      <LossAndDamageClaimStatusSelector label="Claim Status" name="claimStatus" margin="mb-10" mode="multiple" />
      <LADClaimProcessorSelector label="Claim Processor" name="claimProcessor" margin="mb-10" />
      <div>
        <FormLabel>Filed Date:</FormLabel>
        <Row className="mt-3 align-items-center" gutter={5}>
          <Col sm={24} className="text-left">
            <FormLabel>{t('translation:default.fields.from.label')}</FormLabel>
          </Col>
          <Col sm={24}>
            <DatePicker
              name="startDate"
              placeholder={t('translation:default.fields.createdOn.placeholder')}
              margin="mb-0"
              disableFuture
              disabledTargetDate={endDate}
            />
          </Col>
        </Row>
        <Row className="mt-6 align-items-center" gutter={5}>
          <Col sm={24} className="text-left">
            <FormLabel>{t('translation:default.fields.to.label')} :</FormLabel>
          </Col>
          <Col sm={24}>
            <DatePicker
              name="endDate"
              placeholder={t('translation:default.fields.createdOn.placeholder')}
              margin="mb-0"
              disableFuture={false}
              disabledTargetDate={startDate}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default AdvancedFilters;
